var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3C3C3C",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 6,
    height: 6,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 6,
    height: 6,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 6,
    height: 6,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 6,
    height: 6,
    rx: 2.2
  }))));
}
export default __webpack_public_path__ + "static/media/dashboard.209f28e5.svg";
export { SvgDashboard as ReactComponent };